import { render, staticRenderFns } from "./TicketCloseDialog.vue?vue&type=template&id=32e8513f&"
import script from "./TicketCloseDialog.vue?vue&type=script&lang=js&"
export * from "./TicketCloseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports